import React from 'react';
import PropTypes from 'prop-types';
import { useMutation, useQuery } from 'urql';
import Dialog from '@material-ui/core/Dialog';

import TicketDetailsPopup from './TicketDetailsPopup';
import TicketDetails from './TicketDetails';
import TicketDetailsContext, { useTicketNumber, useTicketNumberUpdate } from './TicketDetailsContext'

const TicketDetailsProvider = ({ children }) => {

  return (
    <>
      <TicketDetailsContext>
        {children}
        <TicketDetailsPopup />
      </TicketDetailsContext>
    </>
  );
}

TicketDetailsProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default TicketDetailsProvider;
